import AnalyticsQueryTemplateTable from 'dashboard/components/AnalyticsQueryTemplateTable';
import LoadingOverlay from 'dashboard/components/LoadingOverlay';
import { AnalyticsQueryTemplatesState } from 'dashboard/redux/slices/analytics-query-templates';

interface DashboardInquiryAnalyticsQueryTemplatesViewProps
  extends Pick<AnalyticsQueryTemplatesState, 'templates'> {
  loading: boolean;
  handleArchive: (id: string) => Promise<void>;
}

const DashboardInquiryAnalyticsQueryTemplatesView = ({
  templates,
  loading,
  handleArchive,
}: DashboardInquiryAnalyticsQueryTemplatesViewProps) => (
  <>
    {loading && <LoadingOverlay />}
    <AnalyticsQueryTemplateTable templates={templates} handleArchive={handleArchive} />
  </>
);

export default DashboardInquiryAnalyticsQueryTemplatesView;
